import React from "react";

import Header from "components/Header";
import Hero from "components/Hero";
import Footer from "components/Footer";

import Routes from "components/Routes";

import { AppContainer } from "./styles";

import { AuthProvider } from "contexts/AuthContext";
import { CompetitionProvider } from "contexts/CompetitionContext";
import { AlertProvider } from "contexts/AlertContext";
import { SiteConfigProvider } from "contexts/SiteConfigContext";

export default function App() {

  return (
    <AppContainer>
      <AlertProvider>
        <AuthProvider>
          <SiteConfigProvider>
            {/* El Header queda adentro del CompetitionProvider porque el menú
                muestra "Postularse" sólo mientras la competición está abierta. */}
            <CompetitionProvider>
              <Header />
              <Hero />
              <Routes />
            </CompetitionProvider>
          </SiteConfigProvider>
        </AuthProvider>
        <Footer />
      </AlertProvider>
    </AppContainer>
  );
}
